import React, { Component } from "react";
import { connect } from "react-redux";
import Label from "egov-ui-kit/utils/translationNode";
import { Taskboard } from "../actionItems";
import InboxData from "../Table";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { httpRequest } from "egov-ui-kit/utils/api";
import { withStyles } from "@material-ui/core/styles";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import orderBy from "lodash/orderBy";
import uniq from "lodash/uniq";
import { toggleSnackbarAndSetText } from "egov-ui-kit/redux/app/actions";
import { prepareFinalObject } from "egov-ui-framework/ui-redux/screen-configuration/actions";
import { getLocaleLabels, transformById } from "egov-ui-framework/ui-utils/commons";
import { getTenantId, localStorageSet, localStorageGet, getLocalization, getLocale } from "egov-ui-kit/utils/localStorageUtils";
import "./index.css";
import Filter from "../Filter";
import TextFieldIcon from "egov-ui-kit/components/TextFieldIcon";
import FilterListIcon from '@material-ui/icons/FilterList';
import Hidden from "@material-ui/core/Hidden";

const getWFstatus = (status) => {
  switch (status) {
    case "INITIATED":
      return "Initiated";
    case "APPLIED":
      return "Pending for Document Verification";
    case "FIELDINSPECTION":
      return "Pending for Field Inspection";
    case "PENDINGPAYMENT":
      return "Pending for Payment";
    case "PENDINGAPPROVAL":
      return "Pending for Approval";
    case "APPROVED":
      return "Approved";
  }
};
const gettoTitleCase = (str, businessService) => {
  if (businessService === "ROADCUTNOC"
    || businessService === 'ADVERTISEMENTNOC'
    || businessService === 'SELLMEATNOC'
    || businessService === 'PETNOC'
    //|| businessService==='ES-BB-PROPERTYMASTER'//PropertyMaster
    || businessService === 'UTROADCUTNOC') {
    return `WF_${businessService}_${str}`
  }
  else if (businessService.indexOf('ES-') > -1) {
    // return `WF_${businessService}_${status}`
    let status = str;
    if (businessService === 'ES-BB-PROPERTYMASTER' || businessService === 'ES-EB-PROPERTYMASTER' || businessService === 'ES-MM-PROPERTYMASTER') {
      if (status.indexOf("ES_BB_PM_ES_PM_") > -1) {
        status = status.replace("ES_BB_PM_ES_PM_", '')
      }
      // if(status.indexOf("ES_PM_")>-1)
      // {
      //   status = status.replace("ES_PM_",'') 
      // }
      if (status.indexOf("ES_EB_PM_") > -1) {
        status = status.replace("ES_EB_PM_", '')
      }
      if (status.indexOf("ES_PM_EB_") > -1) {
        status = status.replace("ES_PM_EB_", '')
      }
      if (status.indexOf("ES_PM_MM_") > -1) {
        status = status.replace("ES_PM_MM_", '')
      }
      if (status.indexOf("ES_PM_") > -1) {
        status = status.replace("ES_PM_", '')
      }
      // if(status.indexOf("ES_PM_EB")>-1)
      // {
      //   status = status.replace("ES_PM_EB",'') 
      // }
    }
    if (businessService === 'ES-BB-CS-ISSUANCEOFNOTICE') {
      if (status.indexOf("ES_BB_ION_") > -1) {
        status = status.replace("ES_BB_ION_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-BB-CS-NOC' || businessService === 'ES-EB-CS-NOC' || businessService === 'ES-MM-OCS-NOC') {
      if (status.indexOf("ES_BB_NOC_") > -1) {
        status = status.replace("ES_BB_NOC_", '')
      }
      if (status.indexOf("ES_EB_NOC_") > -1) {
        status = status.replace("ES_EB_NOC_", '')
      }
      if (status.indexOf("ES_MM_NOC_") > -1) {
        status = status.replace("ES_MM_NOC_", '')
      }
      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-PATNERSHIPDEED') {
      if (status.indexOf("ES_EB_PD_") > -1) {
        status = status.replace("ES_EB_PD_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-ALLOTMENTOFSITE' || businessService === 'ES-MM-OSC-ALLOTMENTOFNEWHOUSE') {

      if (status.indexOf("ES_MM_AONH_") > -1) {
        status = status.replace("ES_MM_AONH_", '')
      }
      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-SALEDEED' || businessService === 'ES-MM-CS-SALEGIFT') {
      if (status.indexOf("ES_EB_SD_") > -1) {
        status = status.replace("ES_EB_SD_", '')
      }

      if (status.indexOf("ES_MM_SG_") > -1) {
        status = status.replace("ES_MM_SG_", '')
      }
      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-NDC' || businessService === 'ES-MM-OCS-NDC') {
      if (status.indexOf("ES_EB_NDC_") > -1) {
        status = status.replace("ES_EB_NDC_", '')
      }

      if (status.indexOf("ES_MM_NDC_") > -1) {
        status = status.replace("ES_MM_NDC_", '')
      }

      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-DUPLICATECOPY') {
      if (status.indexOf("ES_EB_DC_") > -1) {
        status = status.replace("ES_EB_DC_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-FAMILYSETTLEMENT' || businessService === 'ES-MM-CS-FAMILYSETTLEMENT') {
      if (status.indexOf("ES_EB_FS_") > -1) {
        status = status.replace("ES_EB_FS_", '')
      }

      if (status.indexOf("ES_MM_FS_") > -1) {
        status = status.replace("ES_MM_FS_", '')
      }

      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-SCFTOSCO') {
      if (status.indexOf("ES_EB_RTC_") > -1) {
        status = status.replace("ES_EB_RTC_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-LEASEDEED') {
      if (status.indexOf("ES_EB_LD_") > -1) {
        status = status.replace("ES_EB_LD_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-CHANGEINTRADE') {
      if (status.indexOf("ES_EB_CIT_") > -1) {
        status = status.replace("ES_EB_CIT_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-REFUNDODEMD') {
      if (status.indexOf("ES_EB_ROE_") > -1) {
        status = status.replace("ES_EB_ROE_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-INTESTATEDEATH' || businessService === 'ES-MM-CS-INTESTATEDEATH') {
      if (status.indexOf("ES_EB_ID_") > -1) {
        status = status.replace("ES_EB_ID_", '')
      }

      if (status.indexOf("ES_MM_ID_") > -1) {
        status = status.replace("ES_MM_ID_", '')
      }
      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-LEASEHOLDTOFREEHOLD') {
      if (status.indexOf("ES_EB_LTF_") > -1) {
        status = status.replace("ES_EB_LTF_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-UNREGISTEREDWILL' || businessService === 'ES-MM-CS-UNREGISTEREDWILL')//UnRegisteredWill UNREGISTEREDWILL
    {
      if (status.indexOf("ES_EB_URW_") > -1) {
        status = status.replace("ES_EB_URW_", '')
      }

      if (status.indexOf("ES_MM_URW_") > -1) {
        status = status.replace("ES_MM_URW_", '')
      }

      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OT-REGISTEREDWILL' || businessService === 'ES-MM-CS-REGISTEREDWILL')//RegisteredWill
    {
      if (status.indexOf("ES_EB_RW_") > -1) {
        status = status.replace("ES_EB_RW_", '')
      }
      if (status.indexOf("ES_MM_RW_") > -1) {
        status = status.replace("ES_MM_RW_", '')
      }
      if (status.indexOf("ES_MM_") > -1) {
        status = status.replace("ES_MM_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-IS-ISSUANCEOFNOTICE') {
      if (status.indexOf("ES_EB_ION_") > -1) {
        status = status.replace("ES_EB_ION_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-MORTGAGE') {
      if (status.indexOf("ES_EB_MORTGAGE_") > -1) {
        status = status.replace("ES_EB_MORTGAGE_", '')
      }
      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (businessService === 'ES-EB-OCS-MORTGAGEINTIMATION') {

      if (status.indexOf("ES_") > -1) {
        status = status.replace("ES_", '')
      }
    }
    if (status.indexOf('_') > 0) {
      status = status.replaceAll('_', ' ');
    }
    status = status.replace(
      /\w\S*/g,
      function (txt) {
        if (txt.length > 3) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
        else {
          if (txt.toUpperCase() === 'TO'
            || txt.toUpperCase() === 'FOR'
            || txt.toUpperCase() === 'AND'
            || txt.toUpperCase() === 'OF'
            || txt.toUpperCase() === 'BY'
          ) {
            return txt.toLowerCase()
          }
          else {
            return txt;
          }
        }

      }
    );

    return status
  }
  else {
    if(str ==='PENDING_FOR_CONNECTION_ACTIVATION_BY_SUPERINTENDENT' && businessService ==='REGULARWSCONNECTION' )
    {
      //WF_REGULARWSCONNECTION_PENDING_FOR_CONNECTION_ACTIVATION_BY_SUPERINTENDENT
       return "Pending for fills 8th to 13th characters of Account Number by Superintendent"

    }
    else if(str ==='PENDING_FOR_CONNECTION_NUMBER_BY_SUPERINTENDENT' && businessService ==='REGULARWSCONNECTION' )
    {
      //WF_REGULARWSCONNECTION_PENDING_FOR_CONNECTION_ACTIVATION_BY_SUPERINTENDENT
       return "Pending for fills 14th character of Account Number, and completes the process"

    }
    else
    {
    if (str) {
      switch (str) {
        case "INITIATED":
          return "Initiated";
        case "APPLIED":
          return "Pending for Document Verification";
        case "FIELDINSPECTION":
          return "Pending for Field inspection";
        case "PENDINGPAYMENT":
          return "Pending Payment";
        case "PENDINGUPDATE":
          return "Out for Delivery";
        case "PENDINGAPPROVAL":
          return "Pending Approval";
        case "PENDINGASSIGNMENTDRIVER":
          return "Pending Assignment to Driver";
        case "APPROVED":
          return "Approved";
          case "PENDING_FOR_CONNECTION_ACTIVATION_BY_SUPERINTENDENT":
          return "Pending for fills 8th to 13th characters of Account Number by Superintendent";
        default:
          {
            if (str.indexOf('_') > 0) {
              str = str.replaceAll('_', ' ');
            }
            return str.replace(
              /\w\S*/g,
              function (txt) {
                if (txt.length > 3) {
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                }
                else {
                  if (txt.toUpperCase() === 'TO'
                    || txt.toUpperCase() === 'FOR'
                    || txt.toUpperCase() === 'AND'
                    || txt.toUpperCase() === 'OF'
                    || txt.toUpperCase() === 'BY'
                  ) {
                    return txt.toLowerCase()
                  }
                  else {
                    return txt;
                  }
                }

              }
            );
          }
      }
    }
  }
  }
  //return `WF_${businessService}_${str}`
}

const styles = (theme) => ({
  textColorPrimary: {
    color: "red",
  },
});

let localizationLabels = transformById(
  JSON.parse(getLocalization(`localization_${getLocale()}`)),
  "code"
);

class TableData extends Component {
  state = {
    businessServiceSla: {},
    searchFilter: {
      value: '',
      typing: false
    },
    filter: {
      // localityFilter: {
      //   selectedValue: ["ALL"],
      //   dropdownData: [
      //     {
      //       value: "ALL",
      //       label: "CS_INBOX_SELECT_ALL",
      //     }
      //   ]
      // },
      moduleFilter: {
        selectedValue: ["ALL"],
        dropdownData: [
          {
            value: "ALL",
            label: "CS_INBOX_SELECT_ALL",
          }
        ]
      },
      statusFilter: {
        selectedValue: ["ALL"],
        dropdownData: [
          {
            value: "ALL",
            label: "CS_INBOX_SELECT_ALL",
          }
        ]
      }
    },
    showFilter: false,
    value: 0,
    tabData: [{ label: "COMMON_INBOX_TAB_ASSIGNED_TO_ME", dynamicArray: [0] }
      , { label: "COMMON_INBOX_TAB_ALL", dynamicArray: [0] }],
    taskboardData: [{ head: 0, body: "WF_TOTAL_TASK", color: "rgb(171,211,237)", baseColor: "rgb(53,152,219)" },
      // { head: 0, body: "WF_TOTAL_NEARING_SLA", color: "rgb(238, 167, 58 ,0.38)", baseColor: "#EEA73A" },
      // { head: 0, body: "WF_ESCALATED_SLA", color: "rgb(244, 67, 54 ,0.38)", baseColor: "#F44336" }
    ],
    taskboardLabel: '',
    inboxData: [{ headers: [], rows: [] }],
    initialInboxData: [{ headers: [], rows: [] }],
    moduleName: "",
    loaded: false,
    color: "rgb(53,152,219)",
    timeoutForTyping: false
  };

  getUniqueList = (list = []) => {
    let newList = [];
    list.map(element => {
      if (!JSON.stringify(newList).includes(JSON.stringify(element))) {
        newList.push(element);
      }
    })
    return newList;
  }
  checkMatch = (row, value) => {
    if (value.length <= 2) {
      return true;
    }
    if (row[5].hiddenField.length !== 6) {
      if (row[0].text.toLowerCase().includes(value.toLowerCase()) ||
        row[3].text.props.label.toLowerCase().includes(value.toLowerCase()) ||
        String(row[4].text).toLowerCase().includes(value.toLowerCase()) ||
        getLocaleLabels("", `CS_COMMON_INBOX_${row[2].text.props.label.split('_')[1]}`).toLowerCase().includes(value.toLowerCase(), localizationLabels) ||
        getLocaleLabels("", row[1].text.props.label).toLowerCase().includes(value.toLowerCase(), localizationLabels) ||
        getLocaleLabels("", row[2].text.props.label).toLowerCase().includes(value.toLowerCase(), localizationLabels)
      ) {
        return true;
      }


    }
    if (
      row[5].hiddenField[0].includes(value.toLowerCase()) ||
      row[5].hiddenField[1].includes(value.toLowerCase()) ||
      row[5].hiddenField[2].includes(value.toLowerCase()) ||
      row[5].hiddenField[3].includes(value.toLowerCase()) ||
      row[5].hiddenField[4].includes(value.toLowerCase()) ||
      row[5].hiddenField[5].includes(value.toLowerCase())

    ) {
      return true;
    }
    return false;
  }
  handleChangeSearch = (value) => {
    this.setState({
      searchFilter: { value, typing: true }
    })
  }

  checkSLA = (taskboardLabel, row) => {
    const MAX_SLA = this.state.businessServiceSla[row[2].text.props.label.split('_')[1]];
    if (taskboardLabel == '' || taskboardLabel == 'WF_TOTAL_TASK') {
      return true;
    } else if ((taskboardLabel == 'WF_TOTAL_NEARING_SLA' && row[4].text > 0 && row[4].text <= (MAX_SLA - MAX_SLA / 3))) {
      return true;
    } else if ((taskboardLabel == 'WF_ESCALATED_SLA' && row[4].text <= 0)) {
      return true;
    } else {
      return false;
    }
  }
  checkRow = (row, filter, searchFilter, taskboardLabel) => {
    //if ((filter.localityFilter.selectedValue.includes('ALL') || filter.localityFilter.selectedValue.includes(row[1].text.props.label)) &&
    // if ((filter.moduleFilter.selectedValue.includes('ALL') || filter.moduleFilter.selectedValue.includes(row[2].text.props.label.split('_')[1])) &&
    //   (filter.statusFilter.selectedValue.includes('ALL') || filter.statusFilter.selectedValue.includes(row[2].text.props.label.split('_')[2])) &&
    //   (searchFilter.value == '' || this.checkMatch(row, searchFilter.value)
    //   )
    // ) {
    //   return true;
    // }
    if (((filter.moduleFilter.selectedValue.includes('ALL') || filter.moduleFilter.selectedValue.includes(row[0].subtext)) &&
      (filter.statusFilter.selectedValue.includes('ALL') || filter.statusFilter.selectedValue.includes(row[2].text.props.label))) &&
      (searchFilter.value == '' || this.checkMatch(row, searchFilter.value)
      )
    ) {
      return true;
    }
    return false;
  }
  convertMillisecondsToDays = (milliseconds) => {
    return (milliseconds / (1000 * 60 * 60 * 24));
  }
  applyFilter = (inboxData) => {
    this.showLoading();
    let initialInboxData = inboxData ? cloneDeep(inboxData) : cloneDeep(this.state.initialInboxData);
    const { filter, searchFilter, taskboardLabel } = this.state;
    let ESCALATED_SLA = [];
    let NEARING_SLA = [];
    let totalRows = []
    if (initialInboxData.length == 2) {
      initialInboxData.map((row, ind) => {
        row.rows = row.rows.filter((eachRow) => {
          let isValid = this.checkRow(eachRow, filter, searchFilter, taskboardLabel);
          if (isValid && ind == 1) {
            let MAX_SLA = this.state.businessServiceSla[eachRow[2].text.props.label.split('_')[1]];
            if (eachRow[4].text <= 0) {
              ESCALATED_SLA.push(eachRow[4].text);
            }
            if (eachRow[4].text > 0 && eachRow[4].text <= (MAX_SLA - MAX_SLA / 3)) {
              NEARING_SLA.push(eachRow[4].text);
            }
            totalRows.push(1);
          }
          if (isValid) {
            return this.checkSLA(taskboardLabel, eachRow);
          }
          return isValid;
        }

        )
      })
    }

    if (initialInboxData.length == 2) {
      initialInboxData.map((row, ind) => {
        row.rows = row.rows.filter((eachRow) => {
          let isValid = this.checkSLA(taskboardLabel, eachRow);
          return isValid;
        }
        )
      })
    }



    let { taskboardData, tabData } = this.state;
    taskboardData[0].head = totalRows.length;
    // taskboardData[1].head = NEARING_SLA.length;
    // taskboardData[2].head = ESCALATED_SLA.length;
    tabData[0].dynamicArray = [initialInboxData[0].rows.length];
    tabData[1].dynamicArray = [initialInboxData[1].rows.length];
    this.hideLoading();
    return {
      inboxData: initialInboxData,
      taskboardData,
      tabData,
    }

  }
  handleChangeFilter = (filterName, value) => {
    const filter = { ...this.state.filter }

    if (value.includes('ALL') && this.state.filter[filterName].selectedValue.includes('ALL') && value.length > 1) {
      value.shift()
    } else if (value.includes('ALL') && value.length > 1 && !this.state.filter[filterName].selectedValue.includes('ALL')) {
      value = ['ALL']
    }
   // filter[filterName].selectedValue = value
    if(value[0] =='ALL')
    {
      let data_ = []
      filter[filterName].dropdownData.forEach(element => {
        data_.push(element.value)
        
      });
      filter[filterName].selectedValue = data_
    }
    else
    {
      if(this.state.filter[filterName].selectedValue.includes('ALL'))
      {
        if((this.state.filter[filterName].selectedValue.length -1) === value.length)
        {
          filter[filterName].selectedValue = []
        }
        else
        {
          filter[filterName].selectedValue = value
        }
        
      }
      else
      {
        filter[filterName].selectedValue = value
      }
      
    }
    
    this.setState({ filter });
  }
  clearFilter = () => {
    const initialInboxData = cloneDeep(this.state.initialInboxData);
    const tempObject = cloneDeep(this.state.initialInboxData);
    const filter = {
      // localityFilter: {
      //   selectedValue: ["ALL"],
      //   dropdownData: [...this.state.filter.localityFilter.dropdownData]
      // },
      moduleFilter: {
        selectedValue: ["ALL"],
        dropdownData: [...this.state.filter.moduleFilter.dropdownData]
      },
      statusFilter: {
        selectedValue: ["ALL"],
        dropdownData: [...this.state.filter.statusFilter.dropdownData]
      }
    }

    this.setState({
      searchFilter: {
        value: '', typing: false
      }, filter, inboxData: initialInboxData,
      initialInboxData: tempObject
    });
  }
  prepareInboxDataRows = async (data, all) => {
    const { toggleSnackbarAndSetText } = this.props;
    if (isEmpty(data)) return [];
    const businessIds = data.map((item) => {
      return item.businessId;
    });
    const businessServiceData = this.getBussinessServiceData();
    const modules =
      businessServiceData &&
      businessServiceData.map((item, index) => {
        return item.business;
      });
    const uniqueModules = uniq(modules)

    let localitymap = [];
    try {
      for (var i = 0; i < uniqueModules.length; i++) {
        try {
          const requestBody = {
            searchCriteria: {
              "referenceNumber": businessIds
            }
          }
          const moduleWiseLocality = //await httpRequest(`egov-searcher/locality/${uniqueModules[i]}/_get`, "search", [], requestBody);
            localitymap = [...localitymap, ...moduleWiseLocality.Localities];
        } catch (e) {
          console.log("error");
        }
      }
    } catch (e) {
      toggleSnackbarAndSetText(
        true,
        {
          labelName: "Locality Empty!",
          labelKey: "Locality Empty!",
        },
        "error"
      );
    }
    let localityDropdownList = [];
    let moduleDropdownList = [];
    let statusDropdownList = [];

    const checkBusinessServices = (businessServices) => {
      let selectedBusinessServices = ["GFCP", "PACC"]
      return !selectedBusinessServices.includes(businessServices)
    }


    const initialData = data.map((item) => {
      const locality = localitymap.find(locality => {
        return locality.referencenumber === item.businessId;
      })
      var sla = item.businesssServiceSla && item.businesssServiceSla / (1000 * 60 * 60 * 24);
      let row0 = { text: item.businessId, subtext: item.businessService, hiddenText: item.moduleName };
      let row1 = { text: locality ? <Label label={`${item.tenantId.toUpperCase().replace(/[.]/g, "_")}_REVENUE_${locality.locality}`} color="#000000" /> : <Label label={"NA"} color="#000000" /> };
      let row2 = {
        text: item.state ? (
          <Label
            // label={`WF_${item.businessService.toUpperCase()}_${item.state.state}`}
            label={gettoTitleCase(item.state.state, item.businessService.toUpperCase())}
            defaultLabel={checkBusinessServices(item.businessService) ? getWFstatus(item.state.state) : undefined}
            color="#000000"
          />
        ) : (
          "NA"
        ),
      };

      let row3 = { text: item.assigner ? <Label label={item.assigner.name} color="#000000" /> : <Label label={"NA"} color="#000000" /> };
      let row4 = { text: Math.round(sla), badge: true };
      let row5 = { historyButton: true };
      let Module = item.businessService.toUpperCase()

      let localityDropdown = { label: getLocaleLabels("", row1.text.props.label, localizationLabels), value: row1.text.props.label };
      localityDropdownList.push(localityDropdown);
      //let moduleDropdown = { label: getLocaleLabels("", `CS_COMMON_INBOX_${row2.text.props.label.split('_')[1]}`, localizationLabels), value: row2.text.props.label.split('_')[1] };
      let moduleDropdown = { label: getLocaleLabels("", `${Module}`, localizationLabels), value: Module };
      moduleDropdownList.push(moduleDropdown);
      //let statusDropdown = { label: getLocaleLabels("", row2.text.props.label, localizationLabels), value: row2.text.props.label.split('_')[2] };
      let statusDropdown = { label: getLocaleLabels("", row2.text.props.label, localizationLabels), value: row2.text.props.label };
      statusDropdownList.push(statusDropdown);

      let dataRows = [
        row0,
        row1,
        row2,
        row3,
        row4,
        {
          ...row5, hiddenField: [row0.text.toLowerCase(),
          String(row4.text),
          getLocaleLabels("", `CS_COMMON_INBOX_${row2.text.props.label.split('_')[1]}`, localizationLabels).toLowerCase(),
          getLocaleLabels("", row1.text.props.label, localizationLabels).toLowerCase(),
          getLocaleLabels("", row2.text.props.label, localizationLabels).toLowerCase(),
          row3.text.props.label.toLowerCase()]
        }
      ];
      return dataRows;
    });

    if (all) {
      this.setState({
        filter: {
          // localityFilter: {
          //   selectedValue: ['ALL'],
          //   dropdownData: this.getUniqueList([
          //     {
          //       value: "ALL",
          //       label: getLocaleLabels("","CS_INBOX_SELECT_ALL",localizationLabels),
          //     }, ...localityDropdownList
          //   ])
          // },
          moduleFilter: {
            selectedValue: ['ALL'],
            dropdownData: this.getUniqueList([
              {
                value: "ALL",
                label: getLocaleLabels("", "CS_INBOX_SELECT_ALL", localizationLabels),
              }, ...moduleDropdownList
            ])
          },
          statusFilter: {
            selectedValue: ['ALL'],
            dropdownData: this.getUniqueList([
              {
                value: "ALL",
                label: getLocaleLabels("", "CS_INBOX_SELECT_ALL", localizationLabels),
              }, ...statusDropdownList
            ])
          }
        }
      });

    }
    return initialData;
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  getBussinessServiceData() {
    let businessServiceData = JSON.parse(localStorageGet("businessServiceData"));
    businessServiceData = businessServiceData ? businessServiceData : this.setBusinessServiceDataToLocalStorage([{ key: "tenantId", value: getTenantId() }]);;
    return businessServiceData;
  }
  getMaxSLA() {
    const businessServiceData = this.getBussinessServiceData();
    let businessServiceSla = {}
    businessServiceData.map(eachRow => {
      businessServiceSla[eachRow.businessService.toUpperCase()] = this.convertMillisecondsToDays(eachRow.businessServiceSla);
    })
    this.setState({ businessServiceSla });
    return businessServiceSla;
  }
  setBusinessServiceDataToLocalStorage = async (queryObject) => {
    const { toggleSnackbarAndSetText } = this.props;
    try {
      const payload = await httpRequest("egov-workflow-v2/egov-wf/businessservice/_search", "_search", queryObject);
      localStorageSet("businessServiceData", JSON.stringify(get(payload, "BusinessServices")));
      return get(payload, "BusinessServices");
    } catch (e) {
      // toggleSnackbarAndSetText(
      //   true,
      //   {
      //     labelName: "Not authorized to access Business Service!",
      //     labelKey: "ERR_NOT_AUTHORISED_BUSINESS_SERVICE",
      //   },
      //   "error"
      // );
    }
  };
  getHorticultureRequestData = (responseData) => {

    var userRolesForHC = []
    var userRolesCodesForHC = []
    var responseDataHorticulture = []
    userRolesForHC = get(this.props, "userInfo.roles");
    userRolesCodesForHC = userRolesForHC.map((item) => { return item.code })

    var horticultureBusinessServices =
      ["PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "REMOVAL OF GREEN TREES",
        "REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "REMOVAL OF FALLEN TREES",
        "UT-PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "UT-PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "UT-REMOVAL OF GREEN TREES",
        "UT-REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "UT-REMOVAL OF FALLEN TREES"]

    // responseDataHorticulture = orderBy(
    //   filter(responseData.ProcessInstances, (item) =>{
    //     if(horticultureBusinessServices.includes(get(item,'businessService'))){



    //     }

    // }),
    //   ["businesssServiceSla"]
    // );
    responseDataHorticulture = responseData.ProcessInstances.filter(x => x.moduleName === 'HORTICULTURE' || x.moduleName === 'UTHORTICULTURE')
    return responseDataHorticulture
  };
  getHorticultureRoleBasedServiceRequestData = (responseData) => {

    var userRolesForHC = []
    var userRolesCodesForHC = []
    var responseDataHorticulture = []
    userRolesForHC = get(this.props, "userInfo.roles");
    userRolesCodesForHC = userRolesForHC.map((item) => { return item.code })

    var horticultureBusinessServices =
      ["PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "REMOVAL OF GREEN TREES",
        "REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "REMOVAL OF FALLEN TREES",
        "UT-PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "UT-PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "UT-REMOVAL OF GREEN TREES",
        "UT-REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "UT-REMOVAL OF FALLEN TREES"]

    responseDataHorticulture = orderBy(
      filter(responseData.ProcessInstances, (item) => {
        if (horticultureBusinessServices.includes(get(item, 'businessService'))) {

          if (get(item, 'additionalDetails') != null && (get(item, 'state.state') != 'REJECTED' || get(item, 'state.state') != 'COMPLETED')) {

            let currentAssignedRole = get(item, 'additionalDetails.role')
            if (currentAssignedRole !== undefined && currentAssignedRole !== null) {
              currentAssignedRole = currentAssignedRole.split(",")

              if (userRolesCodesForHC.some(element => currentAssignedRole.includes(element))) { return item }
            }
          }

        }

      }),
      ["businesssServiceSla"]
    );

    return responseDataHorticulture
  };
  getWaterRoleBasedServiceRequestData = (responseData) => {

    var userRolesForWS = []
    var userRolesCodesForWS = []
    var responseDataWater = []
    userRolesForWS = get(this.props, "userInfo.roles");
    userRolesCodesForWS = userRolesForWS.map((item) => { return item.code })

    var WaterBusinessServices =
      ["REGULARWSCONNECTION",
        "TEMPORARY_WSCONNECTION",
        "TEMPORARY_WSCONNECTION_BILLING",
        "SW_SEWERAGE",
        "WS_TEMP_TEMP",
        "WS_TEMP_REGULAR",
        "WS_DISCONNECTION",
        "WS_TEMP_DISCONNECTION",
        "WS_RENAME",
        "WS_METER_UPDATE",
        "WS_CONVERSION",
        "WS_CONVERSION_TARIFF",
        "WS_REACTIVATE",
        "WS_METER_TESTING",
        "TT_WATER_WORKFLOW",
        "WS_TUBEWELL",]

    responseDataWater = orderBy(
      filter(responseData.ProcessInstances, (item) => {
        if (WaterBusinessServices.includes(get(item, 'businessService'))) {

          if (get(item, 'additionalDetails') != null && (get(item, 'state.state') != 'REJECTED' || get(item, 'state.state') != 'COMPLETED')) {

            let currentAssignedRole = get(item, 'additionalDetails.role')
            if (currentAssignedRole !== undefined) {
              currentAssignedRole = currentAssignedRole.split(",")
              if (userRolesCodesForWS.some(element => currentAssignedRole.includes(element))) { return item }

            }

          }

        }

      }),
      ["businesssServiceSla"]
    );

    return responseDataWater
  };
  getUTRoadRoleBasedServiceRequestData = (responseData) => {

    var userRolesForWS = []
    var userRolesCodesForWS = []
    var responseDataWater = []
    userRolesForWS = get(this.props, "userInfo.roles");
    userRolesCodesForWS = userRolesForWS.map((item) => { return item.code })

    var WaterBusinessServices =
      ["UTROADCUTNOC",
      ]

    responseDataWater = orderBy(
      filter(responseData.ProcessInstances, (item) => {
        if (WaterBusinessServices.includes(get(item, 'businessService'))) {

          if (get(item, 'additionalDetails') != null && (get(item, 'state.state') != 'REJECTED' || get(item, 'state.state') != 'COMPLETED')) {

            let currentAssignedRole = get(item, 'additionalDetails.role')
            if (currentAssignedRole !== undefined && currentAssignedRole !== null && currentAssignedRole !== '') {
              currentAssignedRole = currentAssignedRole.split(",")
              if (userRolesCodesForWS.some(element => currentAssignedRole.includes(element))) { return item }

            }

          }

        }

      }),
      ["businesssServiceSla"]
    );

    return responseDataWater
  };
  getWaterRoleBasedServiceRequestDataWithoutAdditionalDetails = (responseData) => {

    responseData = responseData.ProcessInstances.filter(x => x.additionalDetails === null || x.additionalDetails === undefined)
    // responseData = responseData.ProcessInstances.filter(
    //   x=>x.additionalDetails === null 
    //   || x.additionalDetails === undefined
    //   || x.additionalDetails !== null
    //   )
    // filter(
    //   {

    //   }
    // )

    return responseData
  };
  getOtherApplicationsData = (responseData) => {

    var horticultureBusinessServices =
      ["PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "REMOVAL OF GREEN TREES",
        "REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "REMOVAL OF FALLEN TREES",
        "UT-PRUNING OF TREES GIRTH LESS THAN OR EQUAL TO 90 CMS",
        "UT-PRUNING OF TREES GIRTH GREATER THAN 90 CMS",
        "UT-REMOVAL OF GREEN TREES",
        "UT-REMOVAL OF DEAD/DANGEROUS/DRY TREES",
        "UT-REMOVAL OF FALLEN TREES"]
    var responseDataNonHorticulture = []
    responseDataNonHorticulture = orderBy(
      filter(responseData.ProcessInstances, (item) => {
        if (!horticultureBusinessServices.includes(get(item, 'businessService'))) {
          return item
        }

      }),
      ["businesssServiceSla"]
    );

    return responseDataNonHorticulture
  };
  componentDidMount = async () => {
    const { toggleSnackbarAndSetText, prepareFinalObject } = this.props;
    const uuid = get(this.props, "userInfo.uuid");
    const tenantId = getTenantId();
    let { taskboardData, tabData } = this.state;

    const inboxData = [{ headers: [], rows: [] }];
    try {
      this.showLoading();
      await this.setBusinessServiceDataToLocalStorage([{ key: "tenantId", value: getTenantId() }]);
      const requestBody = [{ key: "tenantId", value: tenantId }];
      const responseData = await httpRequest("egov-workflow-v2/egov-wf/process/_search", "_search", requestBody);


      //Horticulture code changes starts here
      var AssignedToAlldataForHorticulture = []
      //W&S code changes starts here
      var AssignedToAlldataForWNS = []
      var AssignedToAlldataForNOCUTROADCUT = []

      var AssignedToAlldataForOtherModules = []
      AssignedToAlldataForHorticulture = this.getHorticultureRoleBasedServiceRequestData(responseData)//this.getHorticultureRequestData(responseData)//
      AssignedToAlldataForWNS = this.getWaterRoleBasedServiceRequestData(responseData)
      AssignedToAlldataForNOCUTROADCUT = this.getUTRoadRoleBasedServiceRequestData(responseData)
      AssignedToAlldataForOtherModules = this.getOtherApplicationsData(responseData)
      let WithoutAdditionalDetails = responseData
      WithoutAdditionalDetails = this.getWaterRoleBasedServiceRequestDataWithoutAdditionalDetails(WithoutAdditionalDetails)

      var finalDataAssignedToAll = []
      var userRolesForHC = []
      var userRolesCodesForHC = []
      userRolesForHC = get(this.props, "userInfo.roles");
      userRolesCodesForHC = userRolesForHC.map((item) => { return item.code })

      var HC_role = ["HC_JE", "UTHC_JE",
        "HC_SDO", "UTHC_SDO", 'HC_SFO',
        "UTHC_SDE", "TFC_SDO", "TFC_RFO", "TFC_CVR", "HC_SFO", "MCHC_SDE",
        "HC_EE", "UTHC_EE",
        "HC_CCF", "UTHC_CCF", "FRHC_CCF",
        "HC_DCF", "UTHC_DCF", "FRHC_DCF",
        "HC_FRO", "UTHC_FRO", "FRHC_RFO",
        "HC_SRE", "UTHC_CCF",
        "HC_WA", "UTHC_WA",
        "HC_SEHE", "UTHC_SEHE",
        "HC_CEMCC", "UTHC_CEMCC",
        "HC_EEWE", "UTHC_EEWE",
        "HC_COMMISSIONERMCC", "UTHC_COMMISSIONERMCC",
        "UTHC_CEUT",
        "UTHC_CE",
        "HC_SWE", "UTHC_SE"]
      var HCMCC_role = ["HC_JE",
        "HC_SDO",
        "HC_EE",
        "HC_CCF",
        "HC_DCF",
        "HC_FRO",
        "HC_SRE",
        "HC_WA",
        "HC_SEHE",
        "HC_CEMCC",
        "HC_EEWE",
        "HC_COMMISSIONERMCC",
        "TFC_SDO",
        "TFC_RFO",
        "TFC_CVR",
        "MCHC_SDE",
        "HC_SFO",
        "HC_SWE",]
      var HCUT_role = ["UTHC_JE",
        "UTHC_SDO",
        "UTHC_SDE",
        "UTHC_EE",
        "TFC_SDO",
        "TFC_RFO",
        "TFC_CVR",
        "UTHC_CCF",
        "UTHC_DCF",
        "UTHC_FRO",
        "UTHC_SRE",
        "UTHC_WA",
        "UTHC_SEHE",
        "UTHC_STE",
        //"UTHC_CEMCC",
        //"UTHC_EEWE",
        // "UTHC_COMMISSIONERMCC",
        "UTHC_CEUT",
        "UTHC_CE",
        "UTHC_SE"]

      //userRolesCodesForHC.some(element => currentAssignedRole.includes(element))
      if (HC_role.some(element => userRolesCodesForHC.includes(element))) {
        let MccUser = true
        let UTuser = true
        //if(userRolesCodesForHC.some(element => userRolesCodesForHC.includes("UTMCC_EMPLOYEE")))
        if (userRolesCodesForHC.includes("UTMCC_EMPLOYEE")) {
          MccUser = false
          UTuser = false
        }
        else if (HCMCC_role.some(element => userRolesCodesForHC.includes(element))) {
          MccUser = true
          UTuser = false
        }
        else if (HCUT_role.some(element => userRolesCodesForHC.includes(element))) {
          MccUser = false
          UTuser = true
        }

        if (MccUser === true && UTuser === false) {
          AssignedToAlldataForHorticulture = AssignedToAlldataForHorticulture.filter(x => x.businessId.includes('CH-HC'))
          finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules]
        }
        else if (MccUser === false && UTuser === true) {
          AssignedToAlldataForHorticulture = AssignedToAlldataForHorticulture.filter(x => x.businessId.includes('CHD-HC'))
          finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules]
        }
        else {
          finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules]
        }


        //finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules]
        //finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture]
      }
      else if (window.localStorage.getItem("wns_workflow") === 'REGULARWSCONNECTION'
        || window.localStorage.getItem("wns_workflow") === 'SW_SEWERAGE'
        || window.localStorage.getItem("wns_workflow") === 'TEMPORARY_WSCONNECTION'
        || window.localStorage.getItem("wns_workflow") === 'TEMPORARY_WSCONNECTION_BILLING'
        || window.localStorage.getItem("wns_workflow") === "WS_TEMP_TEMP"
        || window.localStorage.getItem("wns_workflow") === "WS_TEMP_REGULAR"
        || window.localStorage.getItem("wns_workflow") === "WS_DISCONNECTION"
        || window.localStorage.getItem("wns_workflow") === "WS_TEMP_DISCONNECTION"
        || window.localStorage.getItem("wns_workflow") === "WS_RENAME"
        || window.localStorage.getItem("wns_workflow") === "WS_METER_UPDATE"
        || window.localStorage.getItem("wns_workflow") === "WS_CONVERSION"
        || window.localStorage.getItem("wns_workflow") === "WS_CONVERSION_TARIFF"
        || window.localStorage.getItem("wns_workflow") === "WS_REACTIVATE"
        || window.localStorage.getItem("wns_workflow") === "WS_TUBEWELL"
        || window.localStorage.getItem("wns_workflow") === "WS_METER_TESTING"
        || window.localStorage.getItem("wns_workflow") === "TT_WATER_WORKFLOW"
      ) {
        finalDataAssignedToAll.ProcessInstances = [...WithoutAdditionalDetails, ...AssignedToAlldataForWNS]

      }
      //  else if(1===1)
      //  {
      //   finalDataAssignedToAll.ProcessInstances = [...WithoutAdditionalDetails, ...AssignedToAlldataForNOCUTROADCUT]
      //  }
      else {
        finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules]

      }

      //finalDataAssignedToAll.ProcessInstances = [...AssignedToAlldataForHorticulture, ...AssignedToAlldataForOtherModules, ...AssignedToAlldataForWNS]

      //horticulture code changes ends here

      const assignedData = orderBy(
        filter(responseData.ProcessInstances, (item) => {
          let assignes = get(item, 'assignee');
          return get(assignes || {}, "uuid") === uuid
        }),
        ["businesssServiceSla"]
      );
      const allData = orderBy(get(finalDataAssignedToAll, "ProcessInstances", []), ["businesssServiceSla"]);


      // const assignedDataRows = []
      // const allDataRows = []

      const assignedDataRows = await this.prepareInboxDataRows(assignedData);
      const allDataRows = await this.prepareInboxDataRows(allData, true);


      let headersList = [
        "WF_INBOX_HEADER_APPLICATION_NO",
        // "WF_INBOX_HEADER_LOCALITY",
        "WF_INBOX_HEADER_STATUS",
        "WF_INBOX_HEADER_CURRENT_OWNER",
        //  "WF_INBOX_HEADER_SLA_DAYS_REMAINING",
      ];
      inboxData[0].headers = headersList;
      inboxData[0].rows = assignedDataRows;

      tabData[0].dynamicArray = [assignedDataRows.length];
      tabData[1].dynamicArray = [allDataRows.length];
      inboxData.push({
        headers: headersList,
        rows: allDataRows,
      });
      let NEARING_SLA = [];
      let ESCALATED_SLA = [];
      const taskCount = allDataRows.length;
      taskboardData[0].head = taskCount;
      // taskboardData[1].head = NEARING_SLA.length;
      //  taskboardData[2].head = ESCALATED_SLA.length;

      this.setState({
        loaded: true,
        inboxData, taskboardData, tabData, initialInboxData: cloneDeep(inboxData)
      });
      this.hideLoading()
    } catch (e) {
      //toggleSnackbarAndSetText(true, { labelName: "Workflow search error !", labelKey: "ERR_SEARCH_ERROR" }, "error");
      this.hideLoading();
    }
    prepareFinalObject("InboxData", [...inboxData]);
    this.getMaxSLA();
  };

  onModuleFilter = (event) => {
    this.setState({ moduleName: event.target.value }, () => {
      const { InboxData } = this.props;
      let { tabData } = this.state;
      const filteredData = InboxData.map((item, index) => {
        return {
          headers: item.headers,
          rows: item.rows.filter((eachRow) => {
            return eachRow[0].subtext === this.state.moduleName;
          }),
        };
      });

      tabData[0] = { label: "COMMON_INBOX_TAB_ASSIGNED_TO_ME", dynamicArray: [filteredData[0].rows.length] };
      tabData[1] = { label: "COMMON_INBOX_TAB_ALL", dynamicArray: [filteredData[1].rows.length] };

      this.setState({
        inboxData: filteredData,
        tabData,
      });
    });
  };

  onTaskBoardClick = (baseColor, label) => {
    this.setState({
      taskboardLabel: label
    });
    this.setState({
      color: baseColor,
    });
  };
  showLoading() {
    const { prepareFinalObject } = this.props;
    prepareFinalObject('Loading.isLoading', true);
  }
  hideLoading() {
    const { prepareFinalObject } = this.props;
    prepareFinalObject('Loading.isLoading', false);
  }
  render() {
    const { value, moduleName, filter, searchFilter, businessServiceSla } = this.state;
    const { classes, onPopupOpen } = this.props;
    const { handleChangeFilter, clearFilter, handleChangeSearch, resetTyping } = this;
    let { taskboardData, tabData, inboxData } = this.state;

    if (this.state.loaded) {
      const filteredData = this.applyFilter();
      taskboardData = filteredData.taskboardData;
      inboxData = filteredData.inboxData;
      tabData = filteredData.tabData;
    }
    return (
      <div className="col-md-12 col-sm-12 col-xs-12">
        <div>
          <div className="container" style={{ marginBottom: '5px', marginTop: '5px', marginLeft: '-20px' }}>
            <div className="col-md-9 col-sm-9 col-xs-12" style={{ marginTop: '5px' }}>
              <Label className="landingPageUser" label={"WF_MY_WORKLIST"} />
            </div>
            <div className="col-md-3 col-sm-3 col-xs-10 search-bar" style={{}}>
              <TextFieldIcon
                hintStyle={{ top: '6px' }}
                iconStyle={{ top: 46 }}
                hintText={getLocaleLabels("", "CS_INBOX_SEARCH", localizationLabels)}
                value={searchFilter.value}
                iconPosition="before"
                className="whiteBackground"
                onChange={(e, value) => {
                  handleChangeSearch(value);
                }}
              />
            </div>
            <div className="icon-hidden filter-icon col-xs-2" onClick={() => {
              this.setState({ showFilter: !this.state.showFilter })
            }}>
              <FilterListIcon />
            </div>
          </div>
          <Hidden only={["xs"]} implementation="css">
            <Filter handleChangeFilter={handleChangeFilter.bind(this)} clearFilter={clearFilter} filter={filter}></Filter></Hidden>
          <Hidden only={["sm", "md", "lg", "xl"]} implementation="css">
            {this.state.showFilter &&
              <Filter handleChangeFilter={handleChangeFilter.bind(this)} clearFilter={clearFilter} filter={filter}></Filter>}
          </Hidden>
        </div>
        <Taskboard data={taskboardData} onSlaClick={this.onTaskBoardClick} color={this.state.color} />
        <div className="backgroundWhite">
          <Tabs
            value={value}
            onChange={this.handleChange}
            className={`inbox-tabs-container ${classes.textColorPrimary}`}
            indicatorColor="primary"
            textColor="primary"
            style={{ borderBottom: "1px solid rgb(211, 211, 211)", textColor: "red", backgroundColor: "white", }}
          >
            {tabData.map((item) => {
              return (
                <Tab className={`inbox-tab ${classes.textColorPrimary}`} label={<Label label={item.label} dynamicArray={item.dynamicArray} />} />
              );
            })}
          </Tabs>
          <InboxData businessServiceSla={businessServiceSla} data={inboxData[value]} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { screenConfiguration, auth } = state;
  const { userInfo } = auth;
  const { preparedFinalObject } = screenConfiguration;
  const { InboxData, isLoading } = preparedFinalObject;

  return { InboxData, userInfo };
};

const mapDispatchToProps = (dispatch) => {
  return {
    prepareFinalObject: (jsonPath, value) => dispatch(prepareFinalObject(jsonPath, value)),
    toggleSnackbarAndSetText: (open, message, error) => dispatch(toggleSnackbarAndSetText(open, message, error)),
  };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(TableData));



// WEBPACK FOOTER //
// ./src/modules/employee/Inbox/components/TableData/index.js